<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Patients",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Members",
            items: [
               {
                  text: "Members",
                  active: true,
               },                   
            ],

            pagination: {},
            listing_length: 10,
            keyword: '',
            modal_title: "Add Member",
            button_title: "Save",
            errors: {},
            members: {
               member_id: null,
               member_name : "",
               gender: "",
               dob: "",
               relation_id : "",
            },
            
            dob: "",
            name : "",
            gender: "",
            age_type: "1",
            age: "",
            relation_id : "",
            relations:[],          
            relationship: "", 
            patient:{},
            loading: false,
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchMembers();
         this.fetchRelations();
      },

      methods: {
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchMembers(page_url = null) {

            this.getToken();
            let url = "clinic/members?keyword=" + this.keyword + "&limit=" + this.listing_length + "&patient_id=" + this.$route.params.id;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.members = responseData.members.data;
                  this.patient = responseData.patient;
      
                  this.pagination = responseData.members.links;
                  this.from = responseData.members.from;
                  this.to = responseData.members.to;
                  this.total = responseData.members.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
         checkNumber() {
            this.getToken();
            let url = "api/admin/member_no?patient_id=" + this.$route.params.id;
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  console.log(responseData.members);
                  if(responseData.members>='6'){
                     this.$swal("", "You can't add more than 6 members", "error");
                  }else{
                     this.showModal("addmember-modal");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            // .finally(() => (this.loading = false));
            // this.showModal("coupon-modal");
         },
         clearForm() {           
            
            this.modal_title = "Add Member";
            this.button_title = "Save";
            this.member.name ="";
            this.member.dob ="";
            this.member.gender ="";   
            this.age_type = "1";
            this.age =  "";    
            
         },
         addMember() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();
            url = "clinic/addMember";
            this.active_page_url = null;

            formData.append("name", this.name); 
            formData.append("age_type", this.age_type); 
            formData.append("age", this.age); 
            formData.append("dob", this.dob); 
            formData.append("gender", this.gender); 
            formData.append("patient_id", this.$route.params.id); 
            formData.append("relation_id", this.relation_id); 

            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('addmember-modal');
                  this.fetchMembers(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         fetchRelations() {
            let url = "api/admin/relationships";          
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.relations = responseData;
               })
               .catch((err) => console.log(err));
         }, 
         setPatient() {
            this.relationship = event.target.options[event.target.options.selectedIndex].label;
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                    <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'patients' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <div class="row">
                     <div class="col-12">
                        <b-media class="mb-4">
                           <b-media-body class="ms-3">
                              <h5 class="mt-1 mb-1">{{patient.patient_name}}</h5>
                              <p>
                                 {{patient.country_code}}{{patient.mobile}}<br>
                                 {{patient.email}}
                              </p>
                           </b-media-body>
                        </b-media>
                     </div>
                  </div> 
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  
                  <div class="row mb-3">
                     <div class="col-12">
                        <!-- <b-button v-b-modal.addmember-modal variant="primary" class="float-end">Add Member</b-button> -->
                        <b-button @click="checkNumber()" variant="primary" class="float-end">Add Member</b-button>

                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchMembers()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @change="fetchMembers()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="20%">Name</th>              
                              <th width="20%">Date of Birth</th>
                              <th width="10%">Gender</th>               
                              <th width="10%">Relation</th>               
                              <th width="20%">Created On</th>
                              <th width="30%">Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(members.length)">
                           <tr v-for="(member) in members" :key="member.member_id">
                              <td>{{member.member_name}}</td>                       
                              <td>{{member.dob}}</td>                       
                              <td>
                                 <span v-if="member.gender==1">Male</span>
                                 <span v-if="member.gender==2">Female</span>
                                 <span v-if="member.gender==3">Others</span>
                              </td>
                              <td>{{member.relationship}}</td> 
                              <td> {{member.converted_created_at}}</td>
                             
                              <td>
                                 <router-link :to="{ name: 'patients.member-details' , params: {id: member.member_id}}" class="btn btn-primary me-2 mb-2 btn-sm">Profile</router-link>
                                 <router-link :to="{ name: 'patients.member-bookings', params: {id: member.member_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Bookings</router-link>      
                                 <router-link :to="{ name: 'patients.member-records' , params: {id: member.member_id}}" class="btn btn-primary me-2 mb-2 btn-sm">Records</router-link>

                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No Members found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(members.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchMembers(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&patient_id=' + this.$route.params.id )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
               <!---- modal starts ---->
                  <b-modal ref="addmember-modal" id="addmember-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addMember()">                        
                        <div class="row"> 
                           
                           <b-form-group md="12">
                              <label>Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="name"  v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           <b-form-group class ="col-md-6">
                              <label>Relation <span class="text-danger">*</span></label>
                              <select class="form-control"  v-model="relation_id" v-bind:class="{ 'is-invalid': Boolean(errors.relation_id) }">
                                 <option value="">Select</option>
                                 <option :value="relation.id" v-for="relation in relations" :key="relation.id">{{relation.relationship}}</option>
                              </select>

                           </b-form-group>
                           <b-form-group class ="col-md-6" v-if="age_type == 1">
                           <label>
                              Age <span class="text-danger">*</span>
                              <span class="ml-2">
                                 <a href="#" @click.prevent="age_type = 2">Enter DOB Instead</a>
                              </span>
                           </label>

                           <b-form-input
                              type="number"
                              v-model="age"
                              min="1"
                              class="form-control"
                              :class="{ 'is-invalid': Boolean(errors.age) }"
                           ></b-form-input>

                           <div v-for="(val, index) in errors.age" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-form-group>
                           <b-form-group class ="col-md-6" v-if="age_type == 2">
                              <label>Date of Birth <span class="text-danger">*</span></label>
                               <span class="ml-2">
                                    <a href="#" @click.prevent="age_type = 1">Enter Age Instead</a>
                                 </span>
                              <input type="date" class="form-control" v-model="dob" :class="{ 'is-invalid': Boolean(errors.dob) }" :max="yesterday"/>
                              <div v-for="(val, index) in errors.dob" :key="index" class="invalid-feedback">
                               <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           <b-form-group  class ="col-md-6">
                              <label>Gender <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="gender" v-bind:class="{ 'is-invalid': Boolean(errors.gender) }">
                                 <option value="">Select</option>
                                 <option :value="1">Male</option>
                                 <option :value="2">Female</option>
                                 <option :value="3">Other</option>
                              </select>
                              <div v-for="(val, index) in errors.gender" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group> 

                           <b-col md="12" class="mt-3">
                                 <div class="page-loader" v-if="!loading">
                                    <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                                    <b-button class="" variant="light" @click="hideModal('addmember-modal')">Close</b-button>
                                 </div>
                                 <div class="page-loader" v-else>
                                    <img src="@/assets/images/preloaderspin.gif"/>
                                 </div>
                           </b-col>
                        </div>                       
                        </b-form>
                     </b-modal>
                  <!---- modal ends ----->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
